import SimplePagination from "./SimplePagination";

export default SimplePagination;
